import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"
import CheckBox from "./CheckBox"

export function CheckBoxField(props) {
  const { className, error, id, label, labelId, name, schema, options, ...otherProps } = props

  return (
    <div
      className={classNames("oj-check-box-field", className)}
      role="group"
      aria-labelledby={labelId}
    >
      <Field error={error}>
        <Field.Label id={labelId} label={label} required={schema.required} />
        <Field.Input id={id} error={error} {...schema}>
          {_.map(options, ({ label: optionLabel, value, checked, ...rest }) => (
            <CheckBox
              key={`${value}-${checked}`}
              {...otherProps}
              {...rest}
              id={`${id}-${value}`}
              name={id}
              label={optionLabel}
              checked={checked}
            />
          ))}
        </Field.Input>
      </Field>
    </div>
  )
}

CheckBoxField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      checked: PropTypes.bool
    })
  ),
  schema: PropTypes.shape(fieldSchemaPropTypes).isRequired,
  onChange: PropTypes.func
}

export default CheckBoxField
